(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    (function () {
    function pad(num) {
      return String(Math.max(0, num)).padStart(2, '0');
    }

    function setDigitValue(unitEl, newValue) {
      var valueEl = unitEl.querySelector('.countdown-digit__value');
      if (!valueEl) return;

      var next = pad(newValue);
      if (valueEl.textContent === next) return;

      valueEl.classList.add('is-popping');

      var handled = false;
      function swap() {
        if (handled) return;
        handled = true;
        valueEl.textContent = next;
        valueEl.classList.remove('is-popping');
      }

      setTimeout(swap, 150);
    }

    function initCountdown(root) {
      if (!root || root.dataset.countdownInitialized === 'true') return;
      root.dataset.countdownInitialized = 'true';

      var targetIso = root.getAttribute('data-target-iso');
      if (!targetIso || targetIso.indexOf('T') === -1) return;

      var target = new Date(targetIso);
      if (isNaN(target.getTime())) return;

      var expireBehavior = root.getAttribute('data-expire-behavior') || 'show_zeros';
      var expiredMessageEl = root.querySelector('.countdown-timer__expired-message');

      var unitEls = {
        days: root.querySelector('.countdown-digit[data-unit="days"]'),
        hours: root.querySelector('.countdown-digit[data-unit="hours"]'),
        minutes: root.querySelector('.countdown-digit[data-unit="minutes"]'),
        seconds: root.querySelector('.countdown-digit[data-unit="seconds"]')
      };

      var timerId = null;

      function tick() {
        var now = new Date();
        var diff = target.getTime() - now.getTime();

        if (diff <= 0) {
          if (unitEls.days) setDigitValue(unitEls.days, 0);
          if (unitEls.hours) setDigitValue(unitEls.hours, 0);
          if (unitEls.minutes) setDigitValue(unitEls.minutes, 0);
          if (unitEls.seconds) setDigitValue(unitEls.seconds, 0);

          if (timerId) clearInterval(timerId);

          if (expireBehavior === 'hide_block') {
            root.classList.add('is-hidden');
          } else if (expireBehavior === 'show_message') {
            root.classList.add('is-expired');
            if (expiredMessageEl) expiredMessageEl.hidden = false;
          }
          return;
        }

        var totalSeconds = Math.floor(diff / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        if (!unitEls.days && unitEls.hours) {
          hours = hours + days * 24;
        }

        if (unitEls.days) setDigitValue(unitEls.days, days);
        if (unitEls.hours) setDigitValue(unitEls.hours, hours);
        if (unitEls.minutes) setDigitValue(unitEls.minutes, minutes);
        if (unitEls.seconds) setDigitValue(unitEls.seconds, seconds);
      }

      tick();
      timerId = setInterval(tick, 1000);
    }

    function initEntranceAnimation(root) {
      var animatedEls = root.querySelectorAll('[data-animate]');
      if (!animatedEls.length) return;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries, obs) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                root.classList.add('is-inview');
                obs.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
        );
        animatedEls.forEach(function (el) {
          observer.observe(el);
        });
      } else {
        root.classList.add('is-inview');
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.countdown-timer').forEach(function (root) {
        initCountdown(root);
        initEntranceAnimation(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
